import util from "../../../util";

const changeTextSearch = ({commit}, payload) => {
  commit('setTextSearch', payload)
}

const searchFile = ({commit}, payload) => {
  commit('setIsSearchAdvanced', false)

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    var params = new URLSearchParams()
    params.append('idClient', payload.idClient)
    params.append('textSearch', payload.textSearch)
    params.append('pageNumber', payload.pageNumber)
    params.append('perPage', payload.perPage)

    payload.context.axios.post('/files/search', params, {headers}).then((response) => {

      commit('setIsSearch', true)
      commit('files/setFiles', {files: response.data.files}, {root: true})
      commit('files/setCountFiles', response.data.count, {root: true})
      resolve(response.data)

    }).catch(error => {
      reject(error)
    });

  })

}

const searchBox = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    var params = new URLSearchParams()
    params.append('idClient', payload.idClient)
    params.append('textSearch', payload.textSearch)
    params.append('pageNumber', payload.pageNumber)
    params.append('perPage', payload.perPage)
    params.append('type', payload.type)

    payload.context.axios.post('/boxes/search', params, {headers}).then((response) => {

      commit('setIsSearch', true)
      commit('boxes/setBoxes', {boxes: response.data.boxes}, {root: true})
      commit('boxes/setCountBoxes', response.data.count, {root: true})
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });

  })

}

const searchPersonalized = ({commit}, payload) => {
  commit('setIsSearchAdvanced', true)

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post('/files/multisearch', payload.request, {headers}).then((response) => {
      commit('setIsSearch', true)
      commit('files/setFiles', {files: response.data.files}, {root: true})
      commit('files/setCountFiles', response.data.count, {root: true})
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  })
}

const searchPersonalizedType = ({commit}, payload) => {
  commit('setIsSearchAdvanced', true)

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post(`/files/multisearch/${payload.type}`, payload.request, {headers}).then((response) => {

      commit('setIsSearch', true)
      commit('files/setFiles', {files: response.data.files}, {root: true})
      commit('files/setCountFiles', response.data.count, {root: true})
      resolve(response.data)

    }).catch(error => {
      reject(error)
    });
  })

}

const searchBoxByFileImport = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    // var params = new URLSearchParams();
    var data = new FormData();
    data.append("file", payload.file);
    //payload.context.axios.post('/files/search',params,{headers}).then((response) => {
    payload.context.axios.post(`/boxes/search/masivo/${payload.idClient}/${payload.type}`, data, {headers}).then((response) => {
      //  commit('setIsSearch', true)
      //  commit('boxes/setBoxesMasivo',{boxes: response.data}, { root: true })
      resolve(response.data)

    }).catch(error => {
      reject(error)
    });

  })

}

const searchPersonalizedV2 = ({commit}, payload) => {
  commit('setIsSearchAdvanced', true)
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post('/files/multisearch/massive', payload.request, {headers}).then((response) => {
      commit('setIsSearch', true)
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  })
}

export default {
  changeTextSearch,
  searchBox,
  searchPersonalized,
  searchPersonalizedType,
  searchFile,
  searchBoxByFileImport,
  searchPersonalizedV2
};



// WEBPACK FOOTER //
// ./src/store/modules/search/actions.js